module.exports = __webpack_public_path__ + "static/imported-samples-b8227ad9155958e58bff5c16b72b7c48.png";